import { useHttpClient } from '@airship-platform/airship-patterns';
import { EmptyState, FlexBox } from '@airship-platform/jam-web/components';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useSearchParams } from 'react-router';
import DataCollectionCompleted from './DataCollectionCompleted';
import { DataCollectionInputs } from './DataCollectionDetails';
import DataCollectionForm from './DataCollectionForm';

const DataCollectionPage: React.FC = () => {
  const httpClient = useHttpClient();
  const [error, setError] = useState<string>();
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const isComplete = searchParams.get('isComplete') === 'true';
  const appointmentId = searchParams.get('appointmentId');
  const token = searchParams.get('token');

  const acceptInvite = async (data: DataCollectionInputs) => {
    try {
      setLoading(true);
      setError(undefined);
      await httpClient.post(
        `/appointments/${appointmentId}/save-data-collection`,
        { ...data, surveyType: 'DEFAULT', token },
        { headers: { Authorization: undefined } }
      );
      setSearchParams((params) => {
        params.set('isComplete', 'true');
        return params;
      });
    } catch (error) {
      return setError(
        error instanceof Error ? error.toString() : 'Unknown error'
      );
    } finally {
      setLoading(false);
    }
  };

  if (!token || !appointmentId) {
    return (
      <EmptyState
        title="Invalid link"
        subtitle="Missing token or appointmentId"
      />
    );
  }

  return (
    <Container maxWidth="sm" disableGutters>
      <FlexBox flexDirection={'column'} gap={2}>
        <Typography variant="h3">
          {isComplete ? 'Thanks!' : 'Customer survey'}
        </Typography>

        {isComplete ? (
          <DataCollectionCompleted />
        ) : (
          <DataCollectionForm onSubmit={acceptInvite} isLoading={loading} />
        )}
        {error && <Typography color="error">{error}</Typography>}
      </FlexBox>
    </Container>
  );
};

export default DataCollectionPage;
